import type { Experience } from '../types/resume';

export const experience: Experience[] = [
  {
    id: 'momentum-current',
    organization: 'Momentum Consulting',
    period: 'Sep 2022 – Present',
    duration: '4 yrs 2 mos',
    employment: 'Part-time · Hybrid',
    location: 'Santiago Metropolitan Area',
    sector: 'Business & digital transformation consulting',
    roles: [
      {
        title: 'Business & Digital Transformation Consultant | Strategic Advisor',
        highlights: [
          'Advises organizations and executive leaders on business and digital transformation, strategic planning, operational efficiency, customer strategy, technology-enabled growth and executive leadership',
          'Supports customer-service transformation, process analysis, efficiency initiatives, business planning, market development and commercial strategy',
          'Advises on cybersecurity business initiatives, including Security Operations Center (SOC) development',
          'Supports customer-oriented applications and emerging AI-enabled solutions',
          'Provides executive coaching and strategic advisory support to leaders navigating transformation and organizational change',
        ],
      },
    ],
  },
  {
    id: 'provectis',
    organization: 'Provectis',
    website: 'https://www.provectis.cl',
    period: 'Jan 2023 – Dec 2025',
    duration: '3 yrs',
    employment: 'Part-time · Hybrid',
    location: 'Santiago Metropolitan Region, Chile',
    sector: 'IT services',
    roles: [
      {
        title: 'Chairman of the Board',
        highlights: [
          'Served first as a Board Member and subsequently as Chairman of the Board',
          'Provided governance, strategic oversight and leadership guidance to an IT services organization focused on infrastructure monitoring, cybersecurity, help desk and professional services',
          'Contributed to long-term business strategy, organizational development, leadership alignment and sustainable growth',
        ],
      },
    ],
  },
  {
    id: 'cosmo-consult',
    organization: 'COSMO CONSULT',
    period: 'Dec 2022 – Aug 2023',
    duration: '9 mos',
    employment: 'Full-time · Hybrid',
    location: 'Santiago Metropolitan Region, Chile',
    sector: 'ERP, BI & CRM implementation',
    roles: [
      {
        title: 'LATAM Operations Manager',
        highlights: [
          'Led Latin American operations across Mexico, Colombia, Ecuador, Peru and Chile',
          'Supported regional technology transformation and operational alignment',
          'Led or supported initiatives involving Microsoft Dynamics, Business Intelligence, Power BI and CRM',
          'Strengthened collaboration across regional teams and connected technology initiatives with business and commercial objectives',
        ],
      },
    ],
  },
  {
    id: 'megalabs',
    organization: 'Megalabs Chile',
    website: 'https://www.megalabschile.cl',
    period: 'Jul 2017 – Aug 2022',
    duration: '5 yrs 2 mos',
    employment: 'Full-time',
    location: 'Provincia de Santiago, Chile',
    sector: 'Pharmaceuticals',
    roles: [
      {
        title: 'Chief Information Officer',
        highlights: [
          'Led innovation, optimization and digital transformation initiatives across Megalabs Chile and related business operations',
          'Supported transformation across Megalabs Chile, Garden House Farmacéutica, Leterago Chile and Garden House USA',
          'Connected technology strategy with business priorities, operational requirements and process improvement',
          'Supported organizational modernization and technology-enabled business improvement',
        ],
        projects: [
          'Business processes assessment for all the companies',
          'ERP migration to Microsoft Dynamics 365 cloud, aligned with a change management project',
          'Development of a cloud BI platform on Azure',
          'Control tower for logistics operations',
          'CRM implementation and integration with eCommerce systems for GH USA',
          'Implementation of Enaxis, a quality management solution',
          'Agile and traditional methodologies, including Design Thinking and OKRs',
        ],
      },
    ],
  },
  {
    id: 'intel',
    organization: 'Intel Corporation',
    website: 'https://www.intel.com',
    logo: 'https://cdn.magicpatterns.com/uploads/fCGebEkBZX7iHN7tV6SEg5/pasted-image.jpg',
    period: 'Jul 2005 – Apr 2016',
    duration: '10 yrs 10 mos',
    sector: 'Technology',
    roles: [
      {
        title: 'Market Development Manager – Southern Cone',
        period: 'Jan 2009 – Apr 2016',
        duration: '7 yrs 4 mos',
        highlights: [
          'Led consumer market development across the Southern Cone',
          'Managed multinational channel partners and strategic relationships',
          'Supported introduction of new products through leading retailers in Chile and developed demand-generation initiatives and new channels',
          'Managed a portfolio including HP, Samsung, Acer, Lenovo, Toshiba, Sony and Asus',
        ],
      },
      {
        title: 'Sales Manager – Chile',
        period: 'Jul 2005 – Dec 2008',
        duration: '3 yrs 6 mos',
        highlights: [
          'Led the distribution channel and managed relationships with wholesalers and strategic accounts',
          'Supported sales growth, market-share expansion and revenue objectives through commercial strategy and channel relationships',
        ],
      },
    ],
  },
  {
    id: 'momentum-2004',
    organization: 'Momentum Consulting',
    period: 'Jul 2004 – Jul 2005',
    duration: '1 yr 1 mo',
    sector: 'Strategy consulting',
    roles: [
      {
        title: 'Strategic Consultant',
        highlights: [
          'Developed strategic growth plans for Neosecure and Provectis',
          'Covered market strategy for Chile and Latin America, product and services models, and financial planning for projected operations',
        ],
      },
    ],
  },
  {
    id: 'sun',
    organization: 'Sun Microsystems',
    note: 'Today part of Oracle',
    period: 'Oct 1999 – Jul 2004',
    duration: '4 yrs 10 mos',
    sector: 'Technology',
    roles: [
      {
        title: 'Business Director – Perú',
        period: 'Jan 2003 – Jul 2004',
        duration: '1 yr 7 mos',
        highlights: [
          'Implemented a new sales strategy for Peru based on a country distributor model',
          'Supported the sales team and marketing activities for demand generation',
          'The operation doubled its customer base in one year',
        ],
      },
      {
        title: 'Regional Channel and Strategic Alliances Manager – Andes Region',
        period: 'Jan 2001 – Dec 2002',
        duration: '2 yrs',
        highlights: [
          'Led regional sales through a system-integrator channel',
          'Expanded opportunities through channel activity and new wholesale relationships',
          'Achieved sales goals and reported 97% revenue linearity',
        ],
      },
      {
        title: 'Regional Marketing Manager – Andes Region',
        period: 'Oct 1999 – Dec 2000',
        duration: '1 yr 3 mos',
        highlights: [
          'Led corporate positioning, product marketing, corporate communications, public relations and business intelligence',
          'Developed a new approach to corporate brand positioning through executive events, press management and channel activities',
        ],
      },
    ],
  },
  {
    id: 'sybase',
    organization: 'Sybase',
    note: 'Today an SAP company',
    period: 'Jul 1996 – Jan 1999',
    duration: '2 yrs 7 mos',
    sector: 'Enterprise software',
    roles: [
      {
        title: 'Sales and Marketing Manager Chile & Bolivia',
        highlights: [
          'Led sales and marketing with a team spanning industry sales, technical consultants and marketing',
          'Supported business across Business Intelligence software and projects, ERP and database systems',
          'Developed direct-business follow-up and alliance plans to expand indirect sales',
        ],
      },
    ],
  },
  {
    id: 'synapsis',
    organization: 'Synapsis',
    note: 'Today TIVIT',
    period: '1990 – Jun 1996',
    duration: '6 yrs 6 mos',
    sector: 'Technology solutions',
    roles: [
      {
        title: 'Solutions Sales Manager',
        period: 'Jan 1995 – Jun 1996',
        duration: '1 yr 6 mos',
        highlights: [
          'Led project sales, new-market development and partner relationships',
          'Opened the Peruvian market and won two major contracts with electricity companies in Lima, establishing the base for the Synapsis Peru subsidiary',
        ],
      },
      {
        title: 'Product Manager',
        period: 'Jan 1993 – Dec 1994',
        duration: '2 yrs',
        highlights: [
          'Managed software solutions for utilities, health institutions and pension funds',
          'Developed the market for Xnear Workflow, including pricing, marketing, licensing, launches and regional channel organization',
        ],
      },
      {
        title: 'Projects Pre-Sales Leader',
        period: 'Jan 1991 – Dec 1992',
        duration: '2 yrs',
        highlights: [
          'Led solution analysis, proposal development and product management for projects serving Enersis Holding companies and utilities',
        ],
      },
      {
        title: 'Customer Services Supervisor',
        period: 'Jan 1990 – Dec 1991',
        duration: '2 yrs',
        highlights: [
          'Supported technical proposals and led installation of network and computing platforms at customer sites',
        ],
      },
    ],
  },
  {
    id: 'chilectra',
    organization: 'Chilectra',
    period: 'Apr 1986 – Dec 1989',
    duration: '3 yrs 9 mos',
    sector: 'Electricity utility',
    roles: [
      {
        title: 'Projects Leader',
        highlights: [
          'Developed specialized software projects, including transactional integration between local networks and the Chilectra Data Center',
        ],
      },
    ],
  },
  {
    id: 'adinf',
    organization: 'ADINF',
    period: 'Jan 1984 – Mar 1986',
    duration: '2 yrs 3 mos',
    sector: 'IT services',
    roles: [
      {
        title: 'Systems Engineer',
        highlights: [
          'Provided customer support to organizations in the financial, pension-fund and insurance sectors',
        ],
      },
    ],
  },
];
